module.exports = __webpack_public_path__ + "static/media/about_us_image_detail.cc783656.jpg";